import { CategoryInfoTooltipContent } from '@modules/common/components/CategoryInfoTooltipContent';
import { FormHelperText, Link, Popover } from '@mui/material';

import { useState } from 'react';

export const ReasonCategoryInputHelper = () => {
  const [categoryInfoAnchorEl, setCategoryInfoAnchorEl] =
    useState<HTMLElement | null>(null);
  const handleCategoryPopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setCategoryInfoAnchorEl(event.currentTarget);
  };

  const handleCategoryInfoPopoverClose = () => {
    setCategoryInfoAnchorEl(null);
  };

  const isCategoryInfoPopoverOpen = Boolean(categoryInfoAnchorEl);

  return (
    <FormHelperText sx={{ ml: 0 }}>
      <Link
        component="button"
        variant="body2"
        underline="none"
        onMouseEnter={handleCategoryPopoverOpen}
        onMouseLeave={handleCategoryInfoPopoverClose}
      >
        What are Categories?
      </Link>
      <Popover
        id="category-info-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={isCategoryInfoPopoverOpen}
        anchorEl={categoryInfoAnchorEl}
        onClose={handleCategoryInfoPopoverClose}
        disableRestoreFocus
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <CategoryInfoTooltipContent />
      </Popover>
    </FormHelperText>
  );
};
